module.exports = __webpack_public_path__ + "media/images/weather/105_night-c8de2db2224d51f308711ff48b32f048.png";